export default "__VITE_ASSET__CFZBz6AI__"